import type { CSSProperties, ReactNode } from 'react';
import { cn } from '../lib/utils';

interface Stat {
  /** label / key */
  k: string;
  /** primary value */
  v: ReactNode;
  /** optional unit suffix */
  unit?: string;
}

export interface StatRowProps {
  stats: Stat[];
  className?: string;
}

/** Ruled metric strip: hairlines between the cells and nothing around them.
 *  Stacks to one column on phones, then one column per stat from `sm` up. */
export const StatRow = ({ stats, className }: StatRowProps) => (
  <div
    className={cn(
      'grid grid-cols-1 divide-y divide-rule border-y border-rule sm:divide-x sm:divide-y-0 sm:[grid-template-columns:var(--stat-cols)]',
      className,
    )}
    style={{ '--stat-cols': `repeat(${stats.length}, minmax(0, 1fr))` } as CSSProperties}
  >
    {stats.map((s, i) => (
      <div key={`${s.k}-${i}`} className="min-w-0 py-3 sm:px-4 sm:first:pl-0 sm:last:pr-0">
        <div className="text-12 text-text-3">{s.k}</div>
        <div className="mono mt-1 flex flex-wrap items-baseline gap-2 text-20 font-medium leading-none tracking-[-0.02em] text-text">
          {s.v}
          {s.unit ? <span className="text-12 font-medium text-text-3">{s.unit}</span> : null}
        </div>
      </div>
    ))}
  </div>
);
